import { BaseEntity } from "yt-ng-framework";

export class MesnaZajednicaView extends BaseEntity{
    constructor(){
        super();
    }
    Naziv:string;
    Mesto:string;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Naziv=input.Naziv;
        this.Mesto=input.Mesto;
        return this;
    }

    Serialize(input:MesnaZajednicaView){
        return input;
    }
}